/** Who can be found and hit (DESIGN §4.7 bridges, docs/ENEMIES_V2.md burrowing): the one targeting predicate. */
import { TileKind } from "../../data/balance";
import { Enemy } from "../entities";
import type { LevelSim } from "../levelSim";

/**
 * Whether a tower, shell, splash or beam can find `e` now: not a flyer over a Bridge (DESIGN §4.7) and not a Burrower
 * underground — unless the seeker "sees burrowed" (a tier-4 skill may: pass `seesBurrowed`). Troops and Barracks
 * soldiers never see a burrowed enemy (they test `e.burrowed` themselves; it passes under them).
 */
export function isTargetable(sim: LevelSim, e: Enemy, seesBurrowed = false): boolean {
  if (e.burrowed && !seesBurrowed) return false;
  return !(e.isAir && sim.tileUnder(e) === TileKind.Bridge);
}
